import request from '../axios'
import { baseUrl } from '@/config/env'

interface Params {
	[key: string]: any
}

// 根据层级查商品分类
export const getCategoryList = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/listCategoryByLevel',
		method: 'get',
		params: params
	})

// 根据父级id查下级商品分类
export const getCategoryInfo = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/listCategoryByParentId',
		method: 'get',
		params: params
	})

// 获取商品列表
export const getPageProduct = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/pageProduct',
		method: 'post',
		data: params
	})
// 分类树
export const getCategoryTree = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/categoryTree',
		method: 'get',
		params: params
	})

// 查所有商品标签
export const getListTag = (params: Params) =>
	request({
		url: baseUrl + '/marking/api/mallProduct/listTag',
		method: 'get',
		params: params
	})
